import * as React from "react"

const TextBlockWithBorder = ({css, title, description}) => (
  <div className={`px-0 pt-3 border-t-4 col-span-2 lg:col-span-1 ${css}`}>
    <h4 className="uppercase mb-0 font-bold text-xl pt-3 pb-4">{title}</h4>
    <p className="mb-3 text-skin-base text-lg">{description}</p>
  </div>
)

export default TextBlockWithBorder